import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import './NewAdmin.scss';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import {useHistory} from 'react-router-dom';
import actions from '../../../redux/actions';
import * as yup from 'yup';
import _ from 'lodash';
import ArrowBackComponent from "../../../common/components/ArrowBack/ArrowBack";
import CustomInput from "../../../common/components/CustomInput/CustomInput";
import Button from "../../../common/components/Button/Button";

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const NewAdmin = (props) => {
    const {
        name,
        addAdmin,
        newAdminState,
        cleanNewAdminState,
        showSidebar,
    } = props;
    const validationSchema = yup.object({
        email: yup
            .string('Ingrese email')
            .email('email invalido')
            .required('Ingrese email'),
        lastName: yup.string('Ingrese apellido'),
        firstName: yup.string('Ingrese Nombre'),
    });
    const history = useHistory();
    const formik = useFormik({
        initialValues: {
            email: '',
            lastName: '',
            firstName: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            addAdmin(values);
        },
    });

    useEffect(
        () => {
            if ( newAdminState.success ) {
                cleanNewAdminState();
                history.goBack();
            };
            // eslint-disable-next-line
        }, [newAdminState],
    );

    const handleArrowBack = () => {
        history.goBack();
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}
             style={{backgroundColor: 'transparent', margin: '10px', padding: '10px', paddingRight: '40px'}}>
                <div className="ul-div-sect-header">
                    <div style={{display: 'flex'}}>
                        <div style={{width: '40px', height: '40px', marginRight: '20px'}}>
                            <ArrowBackComponent onClick={handleArrowBack} />
                        </div>
                        <p className="h3 v2-c-text-title">Nuevo Administrador</p>
                    </div>
                </div>
                <div className="ul-div-form">
                    <form className="eu-form" onSubmit={formik.handleSubmit}>
                        <div className="eu-div-container" style={{gap:'15px'}}>
                            <div className="eu-div-input">
                                <CustomInput
                                    label="Nombre"
                                    placeholder="Nombre"
                                    onChange={(value) => formik.setFieldValue('firstName', value)}
                                    value={formik.values.firstName}
                                    type="text"
                                    />
                                <CustomInput
                                    label="Apellido"
                                    placeholder="Apellido"
                                    onChange={(value) => formik.setFieldValue('lastName', value)}
                                    value={formik.values.lastName}
                                    type="text"
                                />
                            </div>
                            <div className="eu-div-input" style={{width:'50%', paddingRight: '10px'}}>
                                <CustomInput
                                    label="Email"
                                    placeholder="Email"
                                    onChange={(value) => formik.setFieldValue('email', value)}
                                    value={formik.values.email}
                                    type="email"
                                />
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='email' className='eu-input-l' />
                            </div>
                            <div className="eu-div-button">
                                <Button type="submit" size="medium">Crear Administrador</Button>
                            </div>
                        </div>

                    </form>
                </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    users: state.home.users,
    columnData: state.home.columnData,
    newAdminState: state.home.newAdminState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    addAdmin: (admin) => dispatch(actions.home.addAdminRequest(admin)),
    cleanNewAdminState: () => dispatch(actions.home.cleanNewAdminState()),
});

NewAdmin.propTypes = {
    name: PropTypes.string,
};


export default connect(mapStateToProps, mapDispatchToProps)(NewAdmin);

